































import Vue from "vue";
import hljs from "highlight.js"; // Import Highlight.js library
import "highlight.js/styles/obsidian.css"; // Import a Highlight.js theme
// eslint-disable-next-line @typescript-eslint/camelcase
import { sa_event } from 'simple-analytics-vue';

export default Vue.extend({
  name: "ProjectDetailsOverlay",
  props: {
    visible: Boolean,
    color: String,
    title: String,
    htmlContent: String,
  },
  mounted() {
    this.highlightCode();
    this.addScrollTracking(); // Add scroll tracking when the component mounts
    this.attachLoaderLogic();
  },
  watch: {
    visible(newVal) {
      // Re-run loader logic when the overlay becomes visible
      if (newVal) {
        this.$nextTick(() => this.attachLoaderLogic());
      }
    },
  },
  updated() {
    this.highlightCode();
  },
  beforeDestroy() {
    this.removeScrollTracking(); // Clean up event listeners
    // this.cleanUpLoader();  
  },
  methods: {
    highlightCode() {
      const blocks = this.$el.querySelectorAll("pre.code-snippet");
      blocks.forEach((block) => {
        hljs.highlightElement(block as HTMLElement);
      });
    },
    attachLoaderLogic() {
      // Locate the iframe and loader in the rendered HTML  
      const iframe = this.$el.querySelector("iframe") as HTMLIFrameElement | null;
      const loader = this.$el.querySelector("#loader") as HTMLElement | null;

      if (!iframe || !loader) return;

      // Attach the onload event to hide the loader
      iframe.onload = () => {
        loader.style.display = "none"; // Hide the loader when iframe finishes loading
      };
    },
    cleanUpLoader() {
      const loader = this.$el.querySelector("#loader") as HTMLElement | null;
      if (loader) {
        loader.style.display = "none";
      }
    },
    addScrollTracking() {
      const content = this.$el.querySelector(".dialog-content");
      if (content) {
        content.addEventListener("scroll", this.trackScrollDepth);
      }
    },
    removeScrollTracking() {
      const content = this.$el.querySelector(".dialog-content");
      if (content) {
        content.removeEventListener("scroll", this.trackScrollDepth);
      }
    },
    trackScrollDepth(event: Event) {
      const target = event.target as HTMLElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight - target.clientHeight;
      const scrollPercentage = Math.round((scrollTop / scrollHeight) * 100);

      // Track the scroll depth
      sa_event('scroll-depth', {
        percentage: scrollPercentage,
        title: this.title,
      });
      console.log("Scroll depth tracked:", scrollPercentage);
    },
    getImage(url: string) {
      console.log("fetching image " + url);
    },
  },
});

